export const sum = (array, key) => {
  if (!array || !key) return 0;
  return array.reduce((acc, obj) => acc + obj[key], 0)
};
